//TOASTS
export const SHOW_TOAST_LOADING = "SHOW_TOAST_LOADING";
export const GET_TOASTS = "GET_TOASTS";
export const GET_TOAST = "GET_TOAST";
export const CREATE_TOAST = "CREATE_TOAST";
export const DELETE_TOAST = "DELETE_TOAST";
export const DELETE_TOASTS = "DELETE_TOASTS";
export const ERROR_TOASTS = "ERROR_TOASTS";
